module.exports = __webpack_public_path__ + "assets/img/bg.a45f3d75.png";